import type { State } from '../../state/types.tsx';

export const getShareAsState = (state: State) => state.ui.Top.TitleBar.ShareReport.shareAs;
